import React, { useCallback } from "react";
import { NumericFormat } from "react-number-format";
import {
  accountListSelector,
  profileDetailsSelector,
  profilePhotoSelector,
  selectedAccountSelector,
} from "../store/selectors/app.selector";
import { useDispatch, useSelector } from "react-redux";
import { Select } from "antd";
import { setSelectedAccount } from "../store/actions/app.action";
import profileIcon from "../assests/new-images/profile_new.png";
import { useTranslation } from "react-i18next";

export default function AccountDisplay({
  type = "image",
  currencyFilter = false,
}) {
  const accountList = useSelector(accountListSelector);
  const dispatch = useDispatch();
  const profileImage = useSelector(profilePhotoSelector);
  const selectedAccount = useSelector(selectedAccountSelector);
  const { t } = useTranslation();

  const handleChangeAccount = useCallback(
    (value) => {
      const selectedAccDetails = accountList.find(
        (ele) => ele.accountNo === value
      );
      dispatch(setSelectedAccount(selectedAccDetails));
    },
    [accountList]
  );

  return (
    <>
      {type === "image" ? (
        <div className="d-flex">
          <img
            src={
              profileImage != null && profileImage.length > 0
                ? `data:image/png;base64,${profileImage}`
                : profileIcon
            }
            alt="account"
            height={45}
            width={45}
          />
          <div>
            <label style={{ marginLeft: 11 }}>
              {t("pages.gepeg.source_account", {
                defaultValue: "Source Account",
              })}
            </label>
            <div>
                <Select
                  value={selectedAccount.accountNo}
                  onChange={handleChangeAccount}
                  className="custom-select"
                  optionLabelProp={"value"}
                  dropdownMatchSelectWidth={false}
                >
                  {accountList.map((account, index) => (
                    <option key={index} value={account.accountNo}>
                      <span className="acc-short-name">
                        {account?.acctShortName}
                      </span>
                      <br />
                      <span style={{ fontSize: "14px" }}>
                        {account?.accountNo}
                      </span>
                      <br />
                      <span style={{ fontSize: "14px" }}>
                        {account?.branchName}
                      </span>
                    </option>
                  ))}
                </Select>
              </div>
            {/* {currencyFilter === false ? (
             <></>
            ) : (
              <div>
                <Select
                  value={selectedAccount.accountNo}
                  onChange={handleChangeAccount}
                  className="custom-select"
                  optionLabelProp={"value"}
                  dropdownMatchSelectWidth={false}
                >
                  {accountList
                    .filter((ele) => ele.accountCurrency !== "USD")
                    .map((account, index) => (
                      <option key={index} value={account.accountNo}>
                        <span className="acc-short-name">
                          {account?.acctShortName}
                        </span>
                        <br />
                        <span style={{ fontSize: "14px" }}>
                          {account?.accountNo}
                        </span>
                        <br />
                        <span style={{ fontSize: "14px" }}>
                          {account?.branchName}
                        </span>
                      </option>
                    ))}
                </Select>
              </div>
            )} */}
            <p style={{ marginLeft: 11 }} className="primary-color">
              {t("common.avl_bal", {
                defaultValue: "Avl Bal",
              })}
              :{" "}
              <span style={{ marginRight: 5 }}>
                {selectedAccount?.accountCurrency}
              </span>
              <NumericFormat
                value={selectedAccount?.avlBalance}
                displayType={"text"}
                thousandSeparator={true}
                prefix={""}
                fixedDecimalScale={true}
                decimalScale={2}
                allowEmptyFormatting
                renderText={(value) => {
                  const [beforeDecimal, afterDecimal] =
                    value.split(".");
                  return (
                    <>
                      <div style={{ display: "inline" }}>
                        {beforeDecimal}
                      </div>
                      <div
                        style={{
                          display: "inline",
                          fontSize: "11px",
                        }}
                      >
                        .{afterDecimal}
                      </div>
                    </>
                  );
                }}
              />
            </p>
          </div>
        </div>
      ) : (
        <div className="col-12">
          <div>
            <label style={{ marginBottom: 8 }}>
              {t("pages.gepeg.source_account", {
                defaultValue: "Source Account",
              })}
            </label>
            <div>
              <Select
                value={selectedAccount?.accountNo}
                onChange={handleChangeAccount}
                optionLabelProp={"value"}
                className="col-12"
                size="large"
              >
                {accountList.map((account, index) => (
                  <option key={index} value={account.accountNo}>
                    <span className="acc-short-name">
                      {account?.acctShortName}
                    </span>
                    <br />
                    <span style={{ fontSize: "12px" }}>
                      {account?.accountNo}
                    </span>
                    <br />
                    <span style={{ fontSize: "12px" }}>
                      {account?.branchName}
                    </span>
                  </option>
                ))}
              </Select>
            </div>
            <p style={{ float: "right" }} className="primary-color">
              {t("common.avl_bal", {
                defaultValue: "Avl Bal",
              })}
              :{" "}
              <span style={{ marginRight: 5 }}>
                {selectedAccount?.accountCurrency}
              </span>
              <NumericFormat
                value={selectedAccount?.avlBalance}
                displayType={"text"}
                thousandSeparator={true}
                prefix={""}
                fixedDecimalScale={true}
                decimalScale={2}
                allowEmptyFormatting
                renderText={(value) => {
                  const [beforeDecimal, afterDecimal] =
                    value.split(".");
                  return (
                    <>
                      <div style={{ display: "inline" }}>
                        {beforeDecimal}
                      </div>
                      <div
                        style={{
                          display: "inline",
                          fontSize: "11px",
                        }}
                      >
                        .{afterDecimal}
                      </div>
                    </>
                  );
                }}
              />
            </p>
          </div>
        </div>
      )}
    </>
  );
}
